export const SorterColumnNumberType = {
  PERCENT: 'PERCENT',
  WITHOUT_DECIMAL: 'WITHOUT_DECIMAL',
  WITH_ONE_DECIMAL: 'WITH_ONE_DECIMAL',
  WITH_NAN: 'WITH_NAN',
};
